/* eslint-disable eqeqeq */
import React from 'react';
import { StyleSheet, View, Text, TouchableOpacity } from 'react-native';
import { TouchableRipple } from 'react-native-paper';

export interface Props {
  /** The line value for duality and age: 6 old yin, 7 young yang, 8 young yin, 9 old yang */
  value: number | undefined;
  /** Function to call in case of line pressed */
  onPress: () => void;
  /** Line position in the datagram, the first line has position 1  */
  position?: number;
  /** Message received from line in a situation */
  message?: string;
  /** Optionally allow choosing line values  */
  choosing?: boolean;
}

const tintColorLight = '#2f95dc';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingTop: '2%',
    paddingBottom: '2%'
  },
  line: {
    flex: 1,
    flexDirection: 'row'
  },
  yin: {
    flex: 2,
    backgroundColor: 'black'
  },
  empty: {
    flex: 1,
    backgroundColor: 'white'
  },
  yang: {
    flex: 1,
    backgroundColor: 'black'
  },
  old: {
    // borderColor: '#ff9900',
    // borderWidth: 2, // TODO: Causes resizing of flex datagram
    // borderStyle: 'solid',
    backgroundColor: '#9e0000'
  },
  young: {},
  choosing: {
    borderColor: tintColorLight,
    borderWidth: 2
  },
  opacity: {
    flex: 1
  },
  ripple: {
    flex: 1
  }
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getLineStyle = (_value: number | undefined) => {
  return styles.line;
};

const getDualityStyle = (value: number | undefined): any[] => {
  const duality = value == 6 || value == 8 ? styles.yin : styles.yang;
  const age = value == 6 || value == 9 ? styles.old : styles.young;

  return [duality, age];
};

const getChoosing = (
  component?: JSX.Element,
  value?: number,
  onPress?: () => void
) => (
  <TouchableOpacity style={styles.opacity}>
    <TouchableRipple
      style={styles.ripple}
      rippleColor={tintColorLight}
      onPress={() => {
        if (onPress) onPress();
      }}
    >
      {component}
    </TouchableRipple>
  </TouchableOpacity>
);

const getDivs = (
  value: number | undefined,
  choosing?: boolean,
  onPress?: () => void
) => {
  const line = getLineStyle(value);
  const duality = getDualityStyle(value);

  const lineStyles = [line, choosing ? styles.choosing : undefined];

  // if (choosing) {
  //   console.log(`choosing with onPress ${JSON.stringify(onPress)}`);
  // }

  let element;
  if (value == 6 || value == 8) {
    element = (
      <View style={lineStyles}>
        <View style={duality} />
        {/* {value == 6 ? (<Span class="dot" text="O" style={styles.empty}/>) : (<View style={styles.empty}/>)} */}
        <View style={styles.empty} />
        <View style={duality} />
      </View>
    );
  } else if (value == 7 || value == 9) {
    element = (
      <View style={lineStyles}>
        <View style={duality} />
      </View>
    );
  } else if (choosing) {
    element = <View style={lineStyles} />;
  }

  return choosing ? getChoosing(element, value, onPress) : element;
};

const getMessage = (message: string | undefined) => {
  if (message) return <Text>{message}</Text>;

  return undefined;
};

const Line = ({ value, message, choosing, onPress }: Props) => {
  React.useState(value);

  return (
    <View style={styles.container}>
      {/* {getPosition(position)} */}
      {getDivs(value, choosing, onPress)}
      {getMessage(message)}
    </View>
  );
};

export default Line;
